<template>
  <span v-if="props.anchor" :id="props.anchor" class="anchor"></span>
  <div class="card" v-bind="$attrs">
    <h4 class="card-header text-uppercase bg-primary">Messages</h4>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageInformations"
            label="Page Informations"
            placeholder="Page Informations"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageInvoice"
            label="Page Facturation"
            placeholder="Page Facturation"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageCompanions"
            label="Page Accompagnants"
            placeholder="Page Accompagnants"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageTransports"
            label="Page Transports"
            placeholder="Page Transports"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageTransfers"
            label="Page Transferts"
            placeholder="Page Transferts"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageHotels"
            label="Page Hôtels"
            placeholder="Page Hôtels"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageOptions"
            label="Page Options"
            placeholder="Page Options"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageDocuments"
            label="Page Documents"
            placeholder="Page Documents"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageRequests"
            label="Page Demandes particulières"
            placeholder="Page Demandes particulières"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pageSummary"
            label="Page Récapitulatif"
            placeholder="Page Récapitulatif"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
        <div class="col-12">
          <RichTextComponent
            value-key="messages.pagePayment"
            label="Page Paiement"
            placeholder="Page Paiement"
            :required="false"
            type="multiline"
            class="mb-3"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue';
import * as zod from 'zod';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const travel = defineModel<AdminTravel>({ required: true });
const validationSchema = defineModel<{ shape: zod.ZodRawShape, anchors?: Record<string, string | undefined> }>('validation-schema',{ required: false, default: () => ({ shape: {} }) });

const props = defineProps<{
  anchor?: string
}>();

onMounted(() => {
  validationSchema.value = {
    shape: {
      messages: zod.object({
        id: zod.number().nonnegative().default(0),
        pageInformations: zod.string().optional(),
        pageInvoice: zod.string().optional(),
        pageCompanions: zod.string().optional(),
        pageTransports: zod.string().optional(),
        pageTransfers: zod.string().optional(),
        pageHotels: zod.string().optional(),
        pageOptions: zod.string().optional(),
        pageDocuments: zod.string().optional(),
        pageRequests: zod.string().optional(),
        pageSummary: zod.string().optional(),
        pagePayment: zod.string().optional(),
      }).optional()
    },
    anchors: {

    }
  }
});
</script>
